import React from 'react';
import Utils from './Utils';
import PageWrapper from './PageWrapper';
import styled from 'styled-components';

import { ProfileHeader, InformationItem, GridspaceLoadingIcon, InputTextBox, TipsBox, FormHeader, FlexForm, FormDescription, GSInputButton, MixerlabText } from './Components'

class RegisterScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phone_number: '',
      message: '',
      submitting: false
    }

  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({submitting: true})

    let data = new FormData();
    data.append("phone_number", this.state.phone_number);
    Utils.apiPost("/profile/register", data)
      .then((response) => {
          if (response.data["message"] === 'Success!') {
            window.location.href = `/profile/post_registration`
          }
          else {
            this.setState({message: response.data['message'], submitting: false})
          }
      })
  };

  render() {
    const { phone_number } = this.state;
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <FlexForm>
          <ProfileHeader>Create A New Mixer Account</ProfileHeader>
          <FormHeader>Google Account Email</FormHeader>
          <FormDescription>This is the email associated with your Mixer account.</FormDescription>
          <InputTextBox
            disabled={true}
            placeholder={this.props.email}
          />
          <FormHeader>US Phone Number</FormHeader>
          <FormDescription>Enter a permanent phone number you can call in with.</FormDescription>
          <InputTextBox
            type="text"
            id="phone_number"
            value={phone_number}
            placeholder={'e.g. 1234567890'}
            onChange={(event) => {this.setState({ phone_number: event.target.value })}}
          />
          <InformationItem>{this.state.message}</InformationItem>
          {this.state.submitting && <GridspaceLoadingIcon />}
          {!this.state.submitting &&
              <GSInputButton 
                type='submit' 
                value="Register" 
                onClick={e => this.handleSubmit(e)}
              />
          }
          <a href="/profile/oauth" className="login-link">Already have an account? Login</a>
        </FlexForm>
      </PageWrapper>
    );
  }
}

export default RegisterScreen;